import { set, createStore, get, keys } from "idb-keyval";
import { EventEmitter } from "events";

const homm3Store = createStore("homm3-ost", "files");
const filePromises: Record<string, Promise<ArrayBuffer | null>> = {};

type StoreEvents = {
  downloadFinish: [filename: string];
  downloadFailed: [filename: string];
  downloadStart: [filename: string];
};

export const storeEvents = new EventEmitter<StoreEvents>();

export const downloadSoundtrackFile = async (filename: string) => {
  const existing = await getSoundtrackFile(filename);

  if (existing) return existing;

  if (filePromises[filename]) {
    return filePromises[filename];
  }

  storeEvents.emit("downloadStart", filename);

  filePromises[filename] = fetch(filename)
    .then((response) => {
      if (response.status !== 200 || !response.headers.get("content-type")?.startsWith("audio/")) {
        throw new Error(`Invalid audio response: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => blob.arrayBuffer())
    .then(async (arrayBuffer) => {
      if (!arrayBuffer.byteLength) throw new Error("Empty audio file");
      await set(filename, arrayBuffer, homm3Store);
      storeEvents.emit("downloadFinish", filename);
      return arrayBuffer;
    })
    .catch(() => {
      storeEvents.emit("downloadFailed", filename);
      return null;
    })
    .finally(() => { delete filePromises[filename]; });

  return filePromises[filename];
};

export const getSoundtrackFile = (filename: string) => {
  return get<ArrayBuffer>(filename, homm3Store);
};

export const getAllFilenames = () => keys(homm3Store);
